var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_vm._l((_vm.widgets),function(v,section){return [_c('section-divider',{key:("d-" + section),attrs:{"text":_vm.$t(section)}}),_c('div',{key:("c-" + section),style:({
        display: 'flex',
        'flex-wrap': 'wrap',
        filter: ("grayscale(" + (Number(section === 'disabled')) + ")")
      })},_vm._l((_vm.widgets[section]),function(widget,i){return _c(require('../widgets/elements/widget_card').default,{key:i,tag:"component",attrs:{"widget":_vm.widgets[section][i],"amo":_vm.amo,"click-handler":function () {
            section === 'enabled' ? _vm.handleCardClick(_vm.widgets[section][i]) : '';
          }}})}),1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }